import { AxiosInstance } from "axios";

export const fetchContainerLogsByNewtQuery = async (
  instance: AxiosInstance,
  newtQuery: any,
  options?: any
): Promise<any[]> => {
  throw Error("not implemented");
};
